import {Component} from '@angular/core';

import {AimoRoutingService} from '../../../cms-structure/routing/aimo-routing.service';
import {Observable} from "rxjs";
import {AimoAuthService} from "../../../service/auth/aimo-auth.service";
import {map} from "rxjs/operators";
import {AimoUxTypeService} from "../../../service/general/aimo-ux-type.service";

@Component({
    selector: 'aimo-cx-top-header-component',
    templateUrl: './aimo-top-header.component.html',
    standalone: false
})
export class AimoTopHeaderComponent {
    isMobileApp$: Observable<boolean>;

    constructor(
        protected aimoRoutingService: AimoRoutingService,
        protected authService: AimoAuthService,
        protected aimoUxTypeService: AimoUxTypeService
    ) {
        this.isMobileApp$ = this.aimoUxTypeService.isMobileApp();
    }

    isPikatukku(): boolean {
        return this.aimoRoutingService.isPikatukku();
    }

    getPikatukku(ssoParam: string, mobileApp: boolean): string {
        return this.aimoRoutingService.getPikatukkuUrl(ssoParam, mobileApp);
    }

    getToimitustukku(ssoParam: string, mobileApp: boolean): string {
        return this.aimoRoutingService.getToimitustukkuUrl(ssoParam, mobileApp);
    }

    getSsoParam(): Observable<string> {
        return this.authService.isUserLoggedIn()
            .pipe(
                map(isLoggedIn => isLoggedIn ? '?sso=true' : '?')
            );
    }
}
